/** @jsxImportSource @emotion/react */
import * as s from './style';
import React from 'react';
import MapPopupFrame from './MapPopupFrame';

const LifeStylePopup = ({ selectedLocation, handlePopupClose, lifeStylePopup }) => {
    const hasLocation = Boolean(selectedLocation);

    const hospitalStats = [
        { label: '상급병원', value: selectedLocation?.hCnt_01_11 },
        { label: '병의원', value: selectedLocation?.hCnt_21_31 },
        { label: '요양병원', value: selectedLocation?.hCnt_28 },
        { label: '치과/병의원', value: selectedLocation?.hCnt_41_51 },
        { label: '조산원', value: selectedLocation?.hCnt_61 },
        { label: '보건소', value: selectedLocation?.hCnt_71_72_73_75 },
        { label: '약국', value: selectedLocation?.hCnt_81 },
        { label: '한방병/의원', value: selectedLocation?.hCnt_92_93 },
    ];

    const educationStats = [
        { label: '유치원', value: selectedLocation?.eCnt_01 },
        { label: '초등학교', value: selectedLocation?.eCnt_02 },
        { label: '중학교', value: selectedLocation?.eCnt_03 },
        { label: '고등학교', value: selectedLocation?.eCnt_04_05_06 },
        { label: '특수학교', value: selectedLocation?.eCnt_07 },
        { label: '대학교', value: selectedLocation?.eCnt_08 },
        { label: '대학원', value: selectedLocation?.eCnt_09 },
        { label: '각종학교', value: selectedLocation?.eCnt_10 }
    ];

    const rows = lifeStylePopup === 'hos' ? hospitalStats : educationStats;

    return (
        <MapPopupFrame
            popupId="lifestyle_popup"
            isVisible={hasLocation}
            title={selectedLocation ? `${selectedLocation.hjdNm} 현황` : ''}
            onClose={handlePopupClose}
            containerCss={s.mapContainer}
        >
            {rows.map((item) => (
                <div className="map-popup-item" key={item.label}>
                    <span className="map-popup-label">{item.label} : </span>
                    <span className="map-popup-value">{item.value || 0} 개소</span>
                </div>
            ))}
        </MapPopupFrame>
    );
};

export default LifeStylePopup;
